import React from "react";
import { useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { isAgreementSigningVisible } from "../utils/pspOnboarding";
import "../Styles/components/signingPendingNotice.scss";

/**
 * Shown inside restriction popups when a merchant agreement is awaiting
 * signature (status SENT). Hidden until PSP credentials have been saved.
 */
export default function SigningPendingNotice({ business: businessProp }) {
	const { t } = useTranslation("common");
	const signingPending = useSelector((state) => state.documents.signingPending);
	const businessFromStore = useSelector((state) => state.businesses.business);
	const defMembership = useSelector((state) => state.defMembership.defMembership);
	const credentials = useSelector((state) => state.payswitch.credentials);
	const paymentCredentials = useSelector((state) => state.payswitch.paymentCredentials);

	const business = businessProp || businessFromStore || defMembership?.business;
	const signerName = business?.signerFullName;
	const signerEmail = business?.signerEmail;
	const signingVisible = isAgreementSigningVisible(signingPending, {
		credentials,
		paymentCredentials,
	});

	if (!signingVisible || (!signerName && !signerEmail)) {
		return null;
	}

	return (
		<p className="dialog_text signing-pending-notice" style={{ marginTop: "0.75rem" }}>
			<Trans
				i18nKey="idoc.signing_pending_contact"
				values={{ name: signerName || t("idoc.signing_pending_signatory"), email: signerEmail || "" }}
				components={{
					1: <strong />,
					2: <strong />,
				}}
			/>
		</p>
	);
}
